import * as React from "react";
import { forwardRef } from "react";
const SvgDotIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6, r: 2.5, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDotIcon);
export { ForwardRef as ReactComponent };
